import { reportSaleByMunicipalityTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_SALE_BY_MUNICIPALITY_FILTERS,
  RESTORE_INITIAL
} = reportSaleByMunicipalityTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportSaleByMunicipalityReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SALE_BY_MUNICIPALITY_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
